function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "50px",
    width: "50px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 54.264 54.264",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90, 27.132, 27.132)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A46F3E"
    },
    d: "M32.051,25.37c0,0,4.991-0.346,9.472-3.666c0,0,5.465-4.594,8.451-9.612 c0,0,0.719-1.881,3.624-1.302c0,0,2.437-1.668-2.011-6.117L49.264,2.35L29.148,22.467L32.051,25.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2D5D7"
    },
    d: "M36.948,30.267C20.837,46.378,8.262,53.513,0,51.615l29.148-29.148L36.948,30.267z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D2D5D7"
    },
    cx: 35.951,
    cy: 20.414,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D2D5D7"
    },
    cx: 47.951,
    cy: 8.414,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M33.759,27.192C19.374,40.978,13.572,44.486,4.467,47.148L1.614,50 c11.375-2.942,17.194-5.709,33.529-21.365L33.759,27.192z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnife);
export default __webpack_public_path__ + "static/media/knife.e78a170223e8d1df63e1d5058aa22503.svg";
export { ForwardRef as ReactComponent };